import { render, staticRenderFns } from "./FilePropertiesModal.vue?vue&type=template&id=19df34da&"
import script from "./FilePropertiesModal.vue?vue&type=script&lang=js&"
export * from "./FilePropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./FilePropertiesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilePropertiesModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/FilePropertiesModal.vue
// module id = 2166
// module chunks = 1